module.exports = __webpack_public_path__ + "static/Background-mp-1.07a5c922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mp-1.jpg
// module id = 111
// module chunks = 133428282160390 225901961288281